import {
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  Space,
  Spin,
  message,
  theme,
  Typography,
  Divider,
  Tabs,
  Button,
  Avatar,
  Empty,
  Radio,
  Card,
  Row
} from 'antd'
import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import { useDispatch, useSelector } from 'react-redux'
import { createBooking, sendOTP, updateBooking } from '../../utils/utils'
import { generateOTP, handleError } from '../../../lib/utils'
import HomeVisitCheckin from './HomeVisitCheckin'
import { readConfig } from '../../../Admin/config/utils/utils'
import bookingsReducer from '../../utils/booking-reducer'
import { executeBooking, registerBooking } from '../../utils/bpm-utils'
import { findAgiliteUser } from '../../../Auth/utils/utils'
import MobileNav from './MobileNav'
import CustomRow from '../../../reusable-components/CustomRow'
import BookingSummary from './widgets/AppointmentSummary'
import { deviceDetect } from 'react-device-detect'
import CustomButton from '../../../reusable-components/CustomButton'
import { handleVerifyAvailability } from '../../utils/lib'
import ServicesEnums from '../../../Admin/services/utils/enums'
import { readClinics } from '../../../Admin/clinics/utils/utils'
import { updateAllBookingsState } from '../../../lib/booking-utils'
import { sendWhatsAppMessage, sendWhatsAppOTPMessage } from '../../../WhatsApp/utils'
import EmbeddedPayment from '../../../PeachPayments/components/EmbeddedPayment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCreditCard, faCoins, faHeartPulse, faMoneyBill } from '@fortawesome/free-solid-svg-icons'
import { hexToRGBA } from '../../../lib/utils'

const BookingFinalize = ({
  prevStep,
  bookingDetails,
  setBookingDetails,
  nextStep,
  isHomeVisit,
  isVirtualVisit,
  patient,
  isReceptionBooking,
  setReceptionLoadIndicator,
  onAfterSuccessfulBooking,
  targetBooking,
  onAfterFailedBooking,
  isScheduledBooking
}) => {
  const dispatch = useDispatch()
  const { token } = theme.useToken()
  // For checkin Questionairre
  const [checkinConfig, setCheckinConfig] = useState()
  const [currentSelection, setCurrentSelection] = useState()
  const [patientSelection, setPatientSelection] = useState([])
  const [patientInput, setPatientInput] = useState()
  const [questionarreLoading, setQuestionarreLoading] = useState(true)
  const [terms, setTerms] = useState()
  const [termsAgreedTo, setTermsAgreedTo] = useState(isReceptionBooking || isScheduledBooking)
  const [additionalInfo, setAdditionalInfo] = useState()
  const [clientForm] = Form.useForm()
  const [displayTerms, setDisplayTerms] = useState()
  const [loading, setLoading] = useState()
  const authState = useSelector((state) => state.auth)
  const state = useSelector((state) => state)
  const serviceInfo =
    state.services.data.find((item) => item._id === bookingDetails.service) ||
    state.virtualServices.data.find((item) => item._id === bookingDetails.service)
  const [mainPatient, setMainPatient] = useState(patient)
  const [isDependant, setIsDependant] = useState(false)
  const [verifying, setVerifying] = useState(false)
  const [formValues, setFormValues] = useState({})

  // Payment States
  const [renderPayment, setRenderPayment] = useState(false)

  // Helper function to get payment method icons
  const getPaymentIcon = (method) => {
    switch (method.toLowerCase()) {
      case 'card':
        return faCreditCard
      case 'cash':
        return faCoins
      case 'medical aid':
        return faHeartPulse
      default:
        return faMoneyBill
    }
  }

  // Check if form is complete for button enabling
  const isFormComplete = () => {
    const hasReasonForVisit =
      serviceInfo.type === ServicesEnums.labels.VITALITY_HEALTH_CHECK ||
      isVirtualVisit ||
      formValues.chiefComplaint?.trim()
    const hasPaymentMethod = isVirtualVisit || formValues.paymentMethod
    const hasTermsAgreed = isReceptionBooking || isScheduledBooking || termsAgreedTo

    return hasReasonForVisit && hasPaymentMethod && hasTermsAgreed
  }

  useEffect(() => {
    if (mainPatient) {
      if (!mainPatient.phoneNumber && !mainPatient.email) {
        handleFindMainPatient()
      }
    }

    // eslint-disable-next-line
  }, [])

  const handleFindMainPatient = async () => {
    let tmpMainPatient = null
    try {
      tmpMainPatient = await findAgiliteUser({ dependants: { $in: [mainPatient._id] } })

      if (tmpMainPatient) {
        setIsDependant(true)
        setMainPatient(tmpMainPatient)
      }
    } catch (e) {
      message.error(handleError(e, true))
    }
  }

  const getCheckinConfig = async () => {
    let tmpConfig = await readConfig()
    setCheckinConfig(tmpConfig[0].checkin)
    setQuestionarreLoading(false)
  }

  useEffect(() => {
    getCheckinConfig()
    handleSetTerms()
    // Initialize form values
    const initialValues = clientForm.getFieldsValue()
    setFormValues(initialValues)
    // eslint-disable-next-line
  }, [])

  // Update form completion check when terms agreement changes
  useEffect(() => {
    // Force re-render when terms agreement changes
    setFormValues((prev) => ({ ...prev }))
  }, [termsAgreedTo])

  const handleSetTerms = () => {
    const tmpTerms = authState.terms.find((i) => {
      if (i.linkedPractice) {
        return i.linkedPractice === bookingDetails.clinicTermsRef
      } else {
        return null
      }
    })
    if (tmpTerms) {
      setTerms(tmpTerms)
    } else {
      setTerms(authState.terms[0])
    }
  }

  const validateBooking = () => {
    if ((isHomeVisit || isVirtualVisit) && !isScheduledBooking) {
      if (!currentSelection) {
        setLoading(false)
        if (setReceptionLoadIndicator) {
          setReceptionLoadIndicator(false)
        }
        return message.error("Please select a reason for patient's visit")
      }

      switch (currentSelection.doctorsText) {
        case 'Sick':
          if (patientSelection.length < 1) {
            setLoading(false)
            if (setReceptionLoadIndicator) {
              setReceptionLoadIndicator(false)
            }
            return message.error('Please select at least one Symptom')
          }
          break
        case 'Injury':
          if (patientSelection.length < 1) {
            setLoading(false)
            setReceptionLoadIndicator(false)
            return message.error('Please select at least one Injury Type')
          }
          break
        case 'Skin':
          if (patientSelection.length < 1) {
            setLoading(false)
            if (setReceptionLoadIndicator) {
              setReceptionLoadIndicator(false)
            }
            return message.error('Please select at least one Skin Ailment Type')
          }
          break
        case 'Aesthetics':
          if (patientSelection.length < 1) {
            setLoading(false)
            if (setReceptionLoadIndicator) {
              setReceptionLoadIndicator(false)
            }
            return message.error('Please select at least one Interest')
          }
          break
        case 'Sports Medicine':
          if (patientSelection.length < 1) {
            setLoading(false)
            if (setReceptionLoadIndicator) {
              setReceptionLoadIndicator(false)
            }
            return message.error('Please select at least one Option')
          }
          break
        default:
          break
      }
    }

    if (isVirtualVisit && !isScheduledBooking && !isReceptionBooking) {
      setRenderPayment(true)
    } else {
      if (isScheduledBooking) {
        handleUpdateBooking()
      } else {
        confirmBooking()
      }
    }
  }

  const confirmBooking = async (callpayGatewayReference) => {
    let tmpCheckinData = {}
    let otp = null
    let tmpBookings = []
    let tmpDashBoardBookings = []
    let processRecord = null
    let processUser = null
    let payload = JSON.parse(JSON.stringify(bookingDetails))
    let clinicData = null
    let bpmKey = null
    let tmpResult = null

    if (setReceptionLoadIndicator) {
      setReceptionLoadIndicator(false)
    }
    setLoading(true)

    try {
      tmpResult = await readClinics({ _id: bookingDetails.clinicRef }, isVirtualVisit)
      clinicData = tmpResult[0]

      // BPM Key
      bpmKey = 'patient_journey'

      payload.medicalProfRef = payload.medicalProf._id
      payload = { ...payload, ...additionalInfo, status: { ...bookingDetails.status, checkedIn: true } }

      if (isHomeVisit || isVirtualVisit) {
        tmpCheckinData.ailment = currentSelection.doctorsText

        if (patientSelection.length > 0) {
          tmpCheckinData.patientSelection = patientSelection
        }

        if (patientInput) {
          tmpCheckinData.patientInput = patientInput
        }

        payload.checkinData = {
          ...tmpCheckinData
        }
      }

      otp = generateOTP(6)
      payload.otp = otp
      setBookingDetails({ ...bookingDetails, ...payload })

      if (isVirtualVisit) {
        payload.isVirtualVisit = true
      }

      // BPM
      if (patient) {
        processUser = `${authState.agiliteUser.firstName} ${authState.agiliteUser.lastName}`
        payload.userRef = patient._id
        setBookingDetails({ ...bookingDetails, ...payload })
      } else {
        processUser = `${authState.agiliteUser.firstName} ${authState.agiliteUser.lastName}`
      }

      processRecord = await registerBooking(bpmKey, processUser)

      if (isHomeVisit && !isVirtualVisit) {
        // If it is a Home Visit and not a Virtual Consultation, we need to go from new booking to nurse examination (skipping the checkin step)
        processRecord = await executeBooking(
          bpmKey,
          processRecord.recordId,
          'submit',
          processUser,
          processRecord.key,
          'screening' // This is the nextStepKey used by BPM, here we are going from patient check in to nurse examination
        )
      } else if (isVirtualVisit) {
        console.log('isVirtualVisit')
        // If Virtual Consultation, we need to go from new booking to doctor diagnosis (skipping the checkin and nurse examination steps)
        processRecord = await executeBooking(
          bpmKey,
          processRecord.recordId,
          'submit',
          processUser,
          processRecord.key,
          'consultation' // This is the nextStepKey used by BPM, here we are going from patient checkin to doctor diagnosis (skipping the nurse examination step)
        )
      } else {
        console.log('isVirtualVisit')
        // If it is a Scheduled Booking, we need to go from new booking to patient check in
        processRecord = await executeBooking(
          bpmKey,
          processRecord.recordId,
          'submit',
          processUser,
          processRecord.key,
          'check_in'
        )
      }

      let newBooking = await createBooking({
        ...payload,
        processRef: processRecord.recordId,
        status: clinicData?.bpmConfig?.find((e) => e.key === processRecord.key)?.key,
        callpayGatewayReference
      })

      if (isReceptionBooking) {
        // Not awaiting this as it is not critical
        sendWhatsAppMessage(mainPatient.phoneNumber, 'appointment_confirmation', [
          { type: 'text', text: `${mainPatient.firstName} ${mainPatient.lastName}` },
          { type: 'text', text: `${bookingDetails.medicalProf.firstName} ${bookingDetails.medicalProf.lastName}` },
          { type: 'text', text: `${dayjs(bookingDetails.bookingDate).format('MMM D, YYYY')}` },
          { type: 'text', text: `${bookingDetails.startTime}` },
          { type: 'text', text: `${clinicData.name}` },
          { type: 'text', text: `${clinicData.phoneNumber}` }
        ])

        if (!isVirtualVisit) {
          sendOTP(otp, { ...bookingDetails, ...mainPatient }, patient, isDependant, clinicData.name)
          sendWhatsAppOTPMessage(mainPatient.phoneNumber, 'otp_authentication', otp)
        }
      } else {
        // Not awaiting this as it is not critical
        sendWhatsAppMessage(authState.agiliteUser.phoneNumber, 'appointment_confirmation', [
          { type: 'text', text: `${authState.agiliteUser.firstName} ${authState.agiliteUser.lastName}` },
          { type: 'text', text: `${bookingDetails.medicalProf.firstName} ${bookingDetails.medicalProf.lastName}` },
          { type: 'text', text: `${dayjs(bookingDetails.bookingDate).format('MMM D, YYYY')}` },
          { type: 'text', text: `${bookingDetails.startTime}` },
          { type: 'text', text: `${clinicData.name}` },
          { type: 'text', text: `${clinicData.phoneNumber}` }
        ])

        if (!isVirtualVisit) {
          sendOTP(otp, { ...bookingDetails, ...authState.agiliteUser }, patient, isDependant, clinicData.name)
          sendWhatsAppOTPMessage(authState.agiliteUser.phoneNumber, 'otp_authentication', otp)
        }
      }

      // Update Bookings State
      if (state.auth.agiliteUser.extraData.role.type === 'patient') {
        // Set temporary booking states to whatever it was previously plus the new booking
        tmpBookings = [...state.bookings.data, newBooking]
        tmpDashBoardBookings = [...state.bookings.dashboardData, newBooking]
        // Sort Bookings by date
        tmpBookings.sort(
          (a, b) =>
            new Date(dayjs(b.bookingDate).set('hours', b.startTime.slice(0, 2)).set('minutes', b.startTime.slice(-2))) -
            new Date(dayjs(a.bookingDate).set('hours', a.startTime.slice(0, 2)).set('minutes', a.startTime.slice(-2)))
        )
        // update the main bookings state for patient this will be in two plces:
        dispatch(bookingsReducer.actions.setRecords(tmpBookings))
        dispatch(bookingsReducer.actions.setDashboardRecords(tmpDashBoardBookings))
      } else {
        tmpDashBoardBookings = [...state.bookings.dashboardData, newBooking]
        dispatch(bookingsReducer.actions.setDashboardRecords(tmpDashBoardBookings))
      }

      message.success('Booking Successful')

      // Show next facet
      if (isReceptionBooking) {
        onAfterSuccessfulBooking()
      } else {
        nextStep()
      }
    } catch (e) {
      handleError(e)
      message.error('Unable to make booking')
    }

    if (setReceptionLoadIndicator) {
      setReceptionLoadIndicator(false)
    }
    setLoading(false)
  }

  const handleUpdateBooking = async () => {
    let updatedBookingRecord = null
    setLoading(true)
    const payload = {}

    // Build payload
    payload.service = bookingDetails.service
    payload.bookingDate = bookingDetails.bookingDate
    payload.medicalProfRef = bookingDetails.medicalProf._id
    payload.startTime = bookingDetails.startTime
    payload.endTime = bookingDetails.endTime
    payload.scheduledBy = authState.agiliteUser._id
    payload.isVirtualVisit = true

    try {
      updatedBookingRecord = await updateBooking(payload, { _id: targetBooking })
    } catch (error) {
      message.error(handleError(error))
    }
    setLoading(false)
    updateAllBookingsState(updatedBookingRecord)
    onAfterSuccessfulBooking({
      bookingDate: updatedBookingRecord.bookingDate,
      endTime: updatedBookingRecord.endTime,
      medicalProfRef: updatedBookingRecord.medicalProfRef,
      service: updatedBookingRecord.service,
      startTime: updatedBookingRecord.startTime
    })
  }

  const handleData = () => {
    const values = clientForm.getFieldsValue()
    setFormValues(values)
    setAdditionalInfo(values)
  }

  const handleChange = (tag, checked) => {
    const nextSelectedTags = checked ? [...patientSelection, tag] : patientSelection.filter((t) => t !== tag)
    clientForm.setFieldsValue({
      patientSelection: []
    })
    setPatientSelection(nextSelectedTags)
  }

  return (
    <>
      {renderPayment ? (
        <EmbeddedPayment
          amount={serviceInfo.rate}
          patientRecord={authState.agiliteUser}
          paymentType={bookingDetails.paymentMethod}
          isAuthorization={true}
          callback={(merchantReference) => {
            confirmBooking(merchantReference)
            setRenderPayment(false)
          }}
        />
      ) : (
        <>
          {terms && !isReceptionBooking ? (
            <Modal
              title={
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    fontSize: '18px',
                    fontWeight: 600,
                    color: '#262626'
                  }}
                >
                  📋 Terms & Conditions
                </div>
              }
              open={displayTerms}
              onOk={() => {
                setDisplayTerms(false)
              }}
              onCancel={() => {
                setDisplayTerms(false)
              }}
              width={700}
              style={{ top: 40 }}
              okText='I Understand'
              okButtonProps={{
                style: {
                  height: '40px',
                  borderRadius: '8px',
                  fontWeight: 600
                }
              }}
              cancelButtonProps={{
                style: {
                  height: '40px',
                  borderRadius: '8px'
                }
              }}
            >
              <div
                style={{
                  padding: '20px 0',
                  borderTop: '1px solid #f0f0f0',
                  marginTop: '16px'
                }}
              >
                <div
                  style={{
                    backgroundColor: '#f6ffed',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    border: '1px solid #b7eb8f',
                    marginBottom: '20px'
                  }}
                >
                  <small
                    style={{
                      color: '#52c41a',
                      fontWeight: 500,
                      fontSize: '13px'
                    }}
                  >
                    Last updated: <strong>{dayjs(terms.dateModified).format('DD MMMM YYYY')}</strong>
                  </small>
                </div>
                <div
                  style={{
                    lineHeight: '1.6',
                    fontSize: '14px',
                    color: '#262626',
                    maxHeight: '400px',
                    overflowY: 'auto',
                    padding: '0 4px'
                  }}
                  dangerouslySetInnerHTML={{ __html: terms.data }}
                />
              </div>
            </Modal>
          ) : undefined}
          <Form
            onFinishFailed={() => {
              message.error('Please ensure all required information has been provided.')
            }}
            onFinish={() => {
              validateBooking()
            }}
            layout='vertical'
            form={clientForm}
            onFieldsChange={() => {
              handleData(clientForm.getFieldsValue())
            }}
          >
            <CustomRow style={{ gap: '16px' }}>
              {isReceptionBooking ? undefined : (
                <Col span={24}>
                  <div
                    style={{
                      backgroundColor: '#fff',
                      borderRadius: '8px',
                      padding: '20px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                      border: '1px solid #f0f0f0'
                    }}
                  >
                    <BookingSummary
                      isScheduledBooking={isScheduledBooking}
                      booking={bookingDetails}
                      patient={patient}
                      serviceInfo={serviceInfo}
                      isVirtualVisit={isVirtualVisit}
                    />
                  </div>
                </Col>
              )}

              {serviceInfo.type !== ServicesEnums.labels.VITALITY_HEALTH_CHECK && !isVirtualVisit ? (
                <Col span={24}>
                  <div
                    style={{
                      backgroundColor: '#fff',
                      borderRadius: '8px',
                      padding: '24px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                      border: '1px solid #f0f0f0'
                    }}
                  >
                    <div style={{ marginBottom: '16px' }}>
                      <h3
                        style={{
                          margin: 0,
                          fontSize: '16px',
                          fontWeight: 600,
                          color: '#262626',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px'
                        }}
                      >
                        📝 Reason for Visit
                      </h3>
                      <p
                        style={{
                          margin: '6px 0 0 0',
                          fontSize: '14px',
                          color: '#8c8c8c',
                          lineHeight: '1.5'
                        }}
                      >
                        Please provide a brief reason for patient's visit
                      </p>
                    </div>
                    <Form.Item
                      style={{ margin: 0 }}
                      rules={[{ required: true, message: "Please provide a reason for patient's visit" }]}
                      name='chiefComplaint'
                    >
                      <Input.TextArea
                        style={{
                          borderRadius: '8px',
                          padding: '12px 16px',
                          fontSize: '14px',
                          lineHeight: '1.5',
                          minHeight: '80px',
                          resize: 'vertical'
                        }}
                        placeholder='e.g., Patient is feeling dizzy and has a headache that started yesterday...'
                        maxLength={60}
                        showCount
                        autoSize={{ minRows: 3, maxRows: 6 }}
                      />
                    </Form.Item>
                  </div>
                </Col>
              ) : undefined}

              {!isVirtualVisit ? (
                <Col span={24}>
                  <div
                    style={{
                      backgroundColor: '#fff',
                      borderRadius: '8px',
                      padding: '24px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                      border: '1px solid #f0f0f0'
                    }}
                  >
                    <div style={{ marginBottom: '16px' }}>
                      <h3
                        style={{
                          margin: 0,
                          fontSize: '16px',
                          fontWeight: 600,
                          color: '#262626',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px'
                        }}
                      >
                        💳 Payment Method
                      </h3>
                      <p
                        style={{
                          margin: '6px 0 0 0',
                          fontSize: '14px',
                          color: '#8c8c8c',
                          lineHeight: '1.5'
                        }}
                      >
                        Patient's preferred payment method
                      </p>
                    </div>
                    <Form.Item
                      style={{ margin: 0 }}
                      rules={[{ required: true, message: 'Please select a payment method' }]}
                      name='paymentMethod'
                    >
                      <Radio.Group style={{ width: '100%' }}>
                        <Row gutter={[16, 16]}>
                          {bookingDetails.paymentMethods.map((option) => (
                            <Col key={option} xs={24} sm={12} md={8}>
                              <div style={{ position: 'relative' }}>
                                <Radio
                                  value={option}
                                  style={{
                                    position: 'absolute',
                                    top: '16px',
                                    right: '16px',
                                    transform: 'scale(1.2)',
                                    zIndex: 2,
                                    pointerEvents: 'none'
                                  }}
                                />
                                <Card
                                  size='small'
                                  style={{
                                    borderRadius: '12px',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer',
                                    height: '100px',
                                    border: `2px solid ${hexToRGBA(token.colorBorder, 0.2)}`,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    position: 'relative'
                                  }}
                                  className='payment-method-card'
                                  bodyStyle={{
                                    padding: '16px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '100%',
                                    width: '100%'
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault()
                                    // Find the hidden radio and trigger its click
                                    const radio = e.currentTarget.parentElement.querySelector('input[type="radio"]')
                                    if (radio) {
                                      radio.click()
                                    }
                                  }}
                                >
                                  {/* Center content - Icon and Text */}
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      gap: '8px',
                                      flex: 1
                                    }}
                                  >
                                    <FontAwesomeIcon
                                      icon={getPaymentIcon(option)}
                                      style={{
                                        fontSize: '28px',
                                        color: token.colorPrimary
                                      }}
                                    />
                                    <Typography.Text
                                      style={{
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        textAlign: 'center'
                                      }}
                                    >
                                      {option}
                                    </Typography.Text>
                                  </div>
                                </Card>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </Radio.Group>
                    </Form.Item>
                  </div>
                </Col>
              ) : undefined}

              {(isHomeVisit || isVirtualVisit) && !isScheduledBooking ? (
                <Col span={24}>
                  <div
                    style={{
                      backgroundColor: '#fff',
                      borderRadius: '8px',
                      padding: '24px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                      border: '1px solid #f0f0f0'
                    }}
                  >
                    {questionarreLoading ? (
                      <div style={{ textAlign: 'center', padding: '40px' }}>
                        <Spin size='large' />
                        <p style={{ marginTop: '16px', color: '#8c8c8c' }}>Loading questionnaire...</p>
                      </div>
                    ) : (
                      <HomeVisitCheckin
                        loading={loading}
                        handleChange={handleChange}
                        bookingService={serviceInfo.checkin?.length > 0 ? serviceInfo.checkin : checkinConfig}
                        currentSelection={currentSelection}
                        setCurrentSelection={setCurrentSelection}
                        patientSelection={patientSelection}
                        setPatientSelection={setPatientSelection}
                        patientInput={patientInput}
                        setPatientInput={setPatientInput}
                      />
                    )}
                  </div>
                </Col>
              ) : null}

              <Col span={24}>
                <div
                  style={{
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    padding: '24px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                    border: '1px solid #f0f0f0'
                  }}
                >
                  {!isVirtualVisit && !isReceptionBooking ? (
                    <div
                      style={{
                        marginBottom: '20px',
                        padding: '16px',
                        backgroundColor: '#fff7e6',
                        borderRadius: '8px',
                        border: '1px solid #ffd591'
                      }}
                    >
                      <h4
                        style={{
                          margin: '0 0 8px 0',
                          fontSize: '14px',
                          fontWeight: 600,
                          color: '#d46b08',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px'
                        }}
                      >
                        ⚠️ Important Notice
                      </h4>
                      <p
                        style={{
                          margin: 0,
                          fontSize: '13px',
                          color: '#ad6800',
                          lineHeight: '1.4'
                        }}
                      >
                        If you do not <strong>cancel</strong> your appointment within <strong>3 hours</strong> of
                        booking time, you will be liable for a <strong>R500</strong> nurse and doctor's fee.
                      </p>
                    </div>
                  ) : undefined}

                  {isReceptionBooking || isScheduledBooking ? undefined : (
                    <div
                      style={{
                        marginBottom: '20px',
                        textAlign: 'center'
                      }}
                    >
                      <div
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '8px',
                          padding: '12px 16px',
                          backgroundColor: '#f6ffed',
                          borderRadius: '8px',
                          border: '1px solid #b7eb8f'
                        }}
                      >
                        <Checkbox
                          onChange={(e) => {
                            setTermsAgreedTo(e.target.checked)
                          }}
                          style={{ margin: 0 }}
                        />
                        <span style={{ fontSize: '14px', color: '#262626' }}>
                          I agree to the{' '}
                          <span
                            style={{
                              color: '#1890ff',
                              cursor: 'pointer',
                              textDecoration: 'underline',
                              fontWeight: 500
                            }}
                            onClick={() => {
                              setDisplayTerms(true)
                            }}
                          >
                            Terms & Conditions
                          </span>
                        </span>
                      </div>
                    </div>
                  )}

                  {deviceDetect().isMobile ? undefined : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', alignItems: 'center' }}>
                      {!isFormComplete() && (
                        <div
                          style={{
                            backgroundColor: '#fff1f0',
                            border: '1px solid #ffccc7',
                            borderRadius: '6px',
                            padding: '8px 12px',
                            fontSize: '13px',
                            color: '#cf1322',
                            textAlign: 'center',
                            marginBottom: '8px'
                          }}
                        >
                          Please complete all required fields before confirming appointment
                        </div>
                      )}
                      <CustomButton
                        text='Confirm Appointment'
                        type='primary'
                        loading={loading || verifying}
                        disabled={!isFormComplete() || loading || verifying}
                        style={{
                          width: '280px',
                          height: '48px',
                          borderRadius: '8px',
                          fontSize: '16px',
                          fontWeight: 600,
                          boxShadow: isFormComplete() ? '0 2px 4px rgba(24, 144, 255, 0.2)' : 'none',
                          border: 'none',
                          opacity: isFormComplete() ? 1 : 0.6,
                          cursor: isFormComplete() ? 'pointer' : 'not-allowed'
                        }}
                        onClick={async () => {
                          if (!isFormComplete()) return
                          if (!termsAgreedTo) return message.error('Please agree to the terms and conditions')
                          try {
                            await handleVerifyAvailability(bookingDetails, setVerifying)
                            clientForm.submit()
                          } catch (e) {
                            message.error(handleError(e))
                          }
                        }}
                      />
                      {isReceptionBooking ? undefined : (
                        <div style={{ textAlign: 'center' }}>
                          <span
                            style={{
                              color: '#8c8c8c',
                              cursor: 'pointer',
                              fontSize: '14px',
                              textDecoration: 'underline',
                              fontWeight: 500,
                              transition: 'color 0.2s'
                            }}
                            onClick={() => {
                              if (!loading && !verifying) {
                                prevStep()
                              }
                            }}
                            onMouseEnter={(e) => (e.target.style.color = '#1890ff')}
                            onMouseLeave={(e) => (e.target.style.color = '#8c8c8c')}
                          >
                            ← Back to Previous Step
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </Col>
            </CustomRow>
          </Form>
          <MobileNav
            isFinalizeStep={true}
            loading={loading}
            bookingDetails={bookingDetails}
            prevStep={prevStep}
            nextStep={nextStep}
            finalizeForm={clientForm}
            finalizeFormDisabled={!termsAgreedTo}
            isVirtualVisit={isVirtualVisit}
          />
          <style jsx global>{`
            .payment-method-card:hover {
              transform: translateY(-2px);
              box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
              border-color: ${token.colorPrimary} !important;
            }

            .payment-method-card .ant-radio-wrapper-checked {
              color: ${token.colorPrimary};
            }

            /* Target the card when its sibling radio is checked */
            .payment-method-card:has(+ .ant-radio-wrapper-checked),
            .ant-radio-wrapper-checked + .payment-method-card,
            .payment-method-card:has(.ant-radio-wrapper-checked) {
              border-color: ${token.colorPrimary} !important;
              background: ${hexToRGBA(token.colorPrimary, 0.08)} !important;
              box-shadow: 0 4px 20px rgba(24, 144, 255, 0.15) !important;
            }

            /* Style for when the radio input is checked */
            input[type='radio']:checked + .payment-method-card,
            .payment-method-card:has(input[type='radio']:checked) {
              border-color: ${token.colorPrimary} !important;
              background: ${hexToRGBA(token.colorPrimary, 0.08)} !important;
              box-shadow: 0 4px 20px rgba(24, 144, 255, 0.15) !important;
            }

            /* Handle the parent container when radio is checked */
            div:has(> .ant-radio-wrapper-checked) .payment-method-card {
              border-color: ${token.colorPrimary} !important;
              background: ${hexToRGBA(token.colorPrimary, 0.08)} !important;
              box-shadow: 0 4px 20px rgba(24, 144, 255, 0.15) !important;
            }
          `}</style>
        </>
      )}
    </>
  )
}

export default BookingFinalize
